import { ImportCsvSearchSchema } from "@/features/import-csv/zod-schemas";
import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

export const Route = createFileRoute("/_staff/app-integrations/import-csv/$id")(
  {
    validateSearch: zodValidator(ImportCsvSearchSchema),
    loader: async ({ params }) => {
      const res = await apiClient.GET(
        "/v2/app-integrations/{id}/overview/app-contract",
        { params: { path: { id: params.id } } },
      );
      return getDataOrThrowApiError(res);
    },
  },
);
